/**
 * Do not edit directly, this file was auto-generated
 */

export const HeadingsH1 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 72,
  fontSize: "48px",
  textDecoration: "none",
};
export const HeadingsH2 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 48,
  fontSize: "32px",
  textDecoration: "none",
};
export const HeadingsH3 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 32,
  fontSize: "24px",
  textDecoration: "none",
};
export const HeadingsH4 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 32,
  fontSize: "22px",
  textDecoration: "none",
};
export const HeadingsH5 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 24,
  fontSize: "20px",
  textDecoration: "none",
};
export const HeadingsH6 = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: 24,
  fontSize: "18px",
  textDecoration: "none",
};
export const CopyLarge100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 24, fontSize: "20px" };
export const CopyLarge200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 24, fontSize: "20px" };
export const CopyMedium100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 24, fontSize: "18px" };
export const CopyMedium200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 24, fontSize: "18px" };
export const CopyParagraph1100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 24, fontSize: "16px" };
export const CopyParagraph1200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 24, fontSize: "16px" };
export const CopyParagraph2100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 24, fontSize: "15px" };
export const CopyParagraph2200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 24, fontSize: "15px" };
export const CopyCaption100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 24, fontSize: "14px" };
export const CopyCaption200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 24, fontSize: "14px" };
export const CopySmall100 = { fontFamily: "DM Sans", fontWeight: 400, lineHeight: 16, fontSize: "12px" };
export const CopySmall200 = { fontFamily: "DM Sans", fontWeight: 500, lineHeight: 16, fontSize: "12px" };
